import { c as _c } from "react/compiler-runtime";
import { FormInput, RadioGroup, RadioGroupDataInterface } from '@systemeio/ui';
import { useAddFunnelStep } from 'modules/funnels/funnel/hooks/use-add-funnel-step';
import { useUpdateFunnelStepQuery } from 'modules/funnels/funnel/hooks/use-update-funnel-step-query';
import { CreateFunnelStepErrorsInterface, CreateFunnelStepInterface } from 'modules/funnels/funnel/types/funnel-step-interface';
import { getFunnelStepPageTypeDataOptions } from 'modules/funnels/funnel/utils/get-funnel-step-page-type-data-options';
import { FunnelId } from 'modules/funnels/types/funnel-interface';
import { useRouter } from 'next/router';
import React, { useState } from 'react';
import CreateModal from 'shared/components/create-modal';
import { FormSelectWithGroups } from 'shared/components/form-select/form-select-with-groups';
import { FunnelGroupEnum, FunnelStepSourceEnum, funnelGroupTitleLocoKeys, funnelStepSourceLocoKeys } from 'shared/enums/funnel-step-type-enum';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { fetchWithFieldErrors } from 'shared/utils/fetch-with-errors';
import { useFunnelStepsList } from '../hooks/use-funnel-steps-list';
import { AddIcon } from '@systemeio/ui/icons';
const defaultValues: CreateFunnelStepInterface = {
  name: '',
  type: undefined,
  funnelStepSource: FunnelStepSourceEnum.ChooseTemplate
};
const defaultErrors: CreateFunnelStepErrorsInterface = {
  fields: {
    name: '',
    type: ''
  }
};
function CreateFunnelStepModal() {
  const $ = _c(51);
  const router = useRouter();
  const {
    t
  } = useLocoTranslation();
  const funnelId = parseInt(router.query.funnelId as string) as FunnelId;
  const {
    mutateFunnelStepsList
  } = useFunnelStepsList(funnelId);
  const [errors, setErrors] = useState(defaultErrors);
  const [opened, setOpened] = useState(false);
  const {
    updateFunnelStepQuery
  } = useUpdateFunnelStepQuery();
  const {
    addFunnelStep
  } = useAddFunnelStep();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => setOpened(false);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const onClose = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setErrors(defaultErrors);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const afterLeave = t1;
  let t2;
  if ($[2] !== addFunnelStep || $[3] !== funnelId || $[4] !== mutateFunnelStepsList || $[5] !== updateFunnelStepQuery) {
    t2 = async data => {
      await fetchWithFieldErrors(async () => {
        const responseData = await addFunnelStep(Number(funnelId), data);
        await mutateFunnelStepsList(data_0 => {
          if (data_0) {
            return [...data_0, responseData];
          }
        }, false);
        updateFunnelStepQuery(responseData.id);
        onClose();
      }, setErrors);
    };
    $[2] = addFunnelStep;
    $[3] = funnelId;
    $[4] = mutateFunnelStepsList;
    $[5] = updateFunnelStepQuery;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const handleCreate = t2;
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = Object.values(FunnelGroupEnum);
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t) {
    t4 = t3.map(key => ({
      id: key,
      caption: t(funnelGroupTitleLocoKeys[key])
    }));
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const funnelStepTypeGroupsData = t4;
  let t5;
  if ($[10] !== t) {
    t5 = t(funnelStepSourceLocoKeys[FunnelStepSourceEnum.ChooseTemplate]);
    $[10] = t;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t5) {
    t6 = {
      id: FunnelStepSourceEnum.ChooseTemplate,
      caption: t5
    };
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t) {
    t7 = t(funnelStepSourceLocoKeys[FunnelStepSourceEnum.StartFromScratch]);
    $[14] = t;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t7) {
    t8 = {
      id: FunnelStepSourceEnum.StartFromScratch,
      caption: t7
    };
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t6 || $[19] !== t8) {
    t9 = [t6, t8];
    $[18] = t6;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  const funnelStepSourceData = t9;
  let t10;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => setOpened(true);
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <AddIcon className="fill-brand-primary" />;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t) {
    t12 = t("dashboard.funnel.create_funnel_step");
    $[23] = t;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t12) {
    t13 = <div className="border-[rgb(var(--text-primary))]/20 cursor-pointer border-b-[1px] px-[15px] py-[15px] shadow-lg ring-1 ring-black/5 last:border-b-transparent" onClick={t10} data-test-element="create-funnel-step-button"><div className="flex items-center justify-center gap-[10px]">{t11}<span className="text-brand-primary text-lg">{t12}</span></div></div>;
    $[25] = t12;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t) {
    t14 = t("dashboard.funnel.funnel_step");
    $[27] = t;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== errors || $[30] !== t) {
    t15 = {
      field: "name",
      onRender: (value, onChange) => <FormInput key="funnel-step-name" label={t("global.name")} value={value} onChange={e => onChange(e.target.value)} error={errors.fields.name} data-test-element="create-funnel-step-name-field" required={true} />
    };
    $[29] = errors;
    $[30] = t;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== errors || $[33] !== funnelStepTypeGroupsData || $[34] !== t) {
    t16 = {
      field: "type",
      onRender: (value_0, onChange_0) => <FormSelectWithGroups key="funnel-step-type" className="sm:min-w-0" data={getFunnelStepPageTypeDataOptions(t)} label={t("global.type")} value={value_0} onChange={value_1 => onChange_0(value_1)} placeholder={t("dashboard.funnel.funnel_step_type_placeholder")} error={errors.fields.type} dataTest={{
        "data-test-element": "create-funnel-step-type-field"
      }} groups={funnelStepTypeGroupsData} required={true} withoutCloseIcon={true} />
    };
    $[32] = errors;
    $[33] = funnelStepTypeGroupsData;
    $[34] = t;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== funnelStepSourceData) {
    t17 = {
      field: "funnelStepSource",
      onRender: (value_2, onChange_1) => <RadioGroup className="items-center" selected={value_2} options={funnelStepSourceData} onChange={value_3 => onChange_1(value_3)} />
    };
    $[36] = funnelStepSourceData;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== t15 || $[39] !== t16 || $[40] !== t17) {
    t18 = [t15, t16, t17];
    $[38] = t15;
    $[39] = t16;
    $[40] = t17;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  let t19;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = ["name", "type"];
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  let t20;
  if ($[43] !== handleCreate || $[44] !== opened || $[45] !== t14 || $[46] !== t18) {
    t20 = <CreateModal opened={opened} onClose={onClose} afterLeave={afterLeave} defaultValues={defaultValues} caption={t14} saveDataAttribute="create-funnel-step-save-button" creatable={t18} onCreate={handleCreate} requiredFields={t19} />;
    $[43] = handleCreate;
    $[44] = opened;
    $[45] = t14;
    $[46] = t18;
    $[47] = t20;
  } else {
    t20 = $[47];
  }
  let t21;
  if ($[48] !== t13 || $[49] !== t20) {
    t21 = <>{t13}{t20}</>;
    $[48] = t13;
    $[49] = t20;
    $[50] = t21;
  } else {
    t21 = $[50];
  }
  return t21;
}
export default CreateFunnelStepModal;